// extracted by mini-css-extract-plugin
module.exports = {"page":"_15226","result":"_15396","hint":"_14516","btn":"_4133"};